import request from '@/utils/request'

export function getBlockIncome(data) {
  return request({
    url: 'agent_admin/host/block/list',
    method: 'post',
    data
  })
}